/* eslint-disable semi */
import { call, put, takeEvery } from 'redux-saga/effects';

import { LINK_MERCHANT_ID, LIST, UNBIND_MERCHANT_ID } from './actionTypes';

import { loading, result } from './actions';
import { getInstance } from '../../firebase/helper';
import { safeDeepGet, safeGet } from 'iotera-base/utility/json';
import Result from 'iotera-base/result';
import {
  listLinkMerchant,
  postLinkMerchant,
  unlinkMerchant,
} from 'Apps/device';
import { APPLICATION_ID } from 'Apps';
// import { createdUser, deletedUser } from 'Apps/device';

function* list() {
  yield put(loading(LIST));
  const firebaseInstance = getInstance();
  let wsResult = yield call(firebaseInstance.pop.listByPopId);
  let bindingList = [];
  let listBinding = [];
  if (safeDeepGet(wsResult, 'code') == Result.SUCCESS) {
    const body = safeGet(wsResult, 'body', {});
    wsResult = yield call(listLinkMerchant, { application_id: APPLICATION_ID });
    if (safeDeepGet(wsResult, 'code') == Result.HTTP.OK) {
      listBinding = safeGet(wsResult, ['body', 'data'], []);
      wsResult = yield call(firebaseInstance.businessPoint.list);
      if (safeGet(wsResult, 'code') == Result.SUCCESS) {
        const bodyBp = safeGet(wsResult, 'body', {});
        listBinding = listBinding.filter(listData => {
          const application_id = safeGet(listData, 'application_id', '');
          return application_id === APPLICATION_ID;
        });

        for (const i in listBinding) {
          const listData = listBinding[i];
          const device_id = safeGet(listData, 'device_id', '');
          const bind_id = safeGet(listData, 'bind_id', '');
          const bpName = safeGet(bodyBp, [device_id, 'name'], '');
          const bind_name = safeGet(body, [bind_id, 'name'], '');
          const is_binding = safeGet(body, [bind_id, 'isBinding'], false);
          listData['device_name'] = bpName;
          listData['bind_name'] = bind_name;
          listData['is_binding'] = is_binding;
        }
      }
      for (const i in body) {
        const result = listBinding.find(item => item.bind_id === i);
        if (result != undefined) {
          bindingList.push(result);
        } else {
          const data = body[i];
          bindingList.push({
            id: i,
            bind_id: i,
            application_id: APPLICATION_ID,
            device_id: null,
            payment_gateway: null,
            active: false,
            products: [
              {
                id: 'MASSAGE',
                name: 'Massage Service',
              },
            ],
            plugin: {},
            extras: {},
            device_name: '',
            bind_name: safeGet(data, 'name', ''),
            is_binding: safeGet(data, 'isBinding', false),
          });
        }
      }
    }
    yield put(result(LIST, { code: Result.SUCCESS, body: bindingList }));
    return;
  }
  yield put(result(LIST, { result: { code: Result.FAILED } }));
}

function* unbindMerchant(action) {
  yield put(loading(UNBIND_MERCHANT_ID));
  const firebaseInstance = getInstance();
  const payload = safeGet(action, 'payload', {});
  const pop_name = safeDeepGet(payload, 'bind_name', null);
  if (pop_name == null) {
    yield put(
      result(UNBIND_MERCHANT_ID, {
        code: Result.FAILED,
        message: 'Nama bind tidak ada',
      })
    );
    return;
  }
  const id = safeDeepGet(payload, 'id', null);
  if (id == null) {
    yield put(
      result(UNBIND_MERCHANT_ID, {
        code: Result.FAILED,
        message: 'id Bind tidak ada',
      })
    );
    return;
  }
  const bodyFb = {
    isBinding: false,
    device_id: '',
  };
  const body = {
    id: id,
  };
  let response = yield call(unlinkMerchant, body);
  let code = safeDeepGet(response, 'code', Result.FAILED);
  if (code != Result.HTTP.OK) {
    yield put(
      result(UNBIND_MERCHANT_ID, {
        code: Result.FAILED,
        message: 'Gagal UnLink di Service',
      })
    );
    return;
  }
  response = yield call(firebaseInstance.pop.update, pop_name, bodyFb);
  code = safeDeepGet(response, 'code', Result.FAILED);
  if (code != Result.SUCCESS) {
    yield put(
      result(UNBIND_MERCHANT_ID, {
        code: Result.FAILED,
        message: 'Gagal UnLink di Database',
      })
    );
    return;
  }

  yield put(result(UNBIND_MERCHANT_ID, { code: Result.SUCCESS, body: body }));
  return;
}

function* linkMerchant(action) {
  yield put(loading(LINK_MERCHANT_ID));
  const deviceId = safeDeepGet(action, ['payload', 'deviceId'], '');
  const pop_name = safeDeepGet(action, ['payload', 'pop_id'], '');
  const firebaseInstance = getInstance();
  const resultPop = yield call(firebaseInstance.pop.read, pop_name);
  const popMap = safeDeepGet(resultPop, 'body', '');
  const cross_reff = safeDeepGet(popMap, 'cross_reff', null);
  const isBinding = safeDeepGet(popMap, 'isBinding', false);
  if (isBinding) {
    yield put(result(LINK_MERCHANT_ID, { code: -3 }));
    return;
  }
  if (cross_reff && !isBinding) {
    const body = {
      bind_id: cross_reff,
      application_id: APPLICATION_ID,
      device_id: deviceId,
      payment_gateway: 'QRIS-MIDTRANS-PARTNER',
      active: true,
      products: [
        {
          id: 'MASSAGE',
          name: 'Massage Service',
        },
      ],
      plugin: {},
      extras: {},
    };
    const wsResult = yield call(postLinkMerchant, body);
    const code = safeDeepGet(wsResult, 'code');
    if (code == Result.HTTP.OK) {
      const body = safeDeepGet(wsResult, 'body', {});
      const bodyFb = {
        isBinding: true,
        device_id: deviceId,
        name: pop_name,
        cross_reff: cross_reff,
      };
      yield call(firebaseInstance.pop.update, pop_name, bodyFb);
      yield call(
        firebaseInstance.businessPoint.updateActiveDate,
        deviceId,
        new Date().getTime()
      );
      yield put(result(LINK_MERCHANT_ID, { code: Result.SUCCESS, body: body }));
      return;
    } else {
      yield put(result(LINK_MERCHANT_ID, { code: Result.FAILED }));
      return;
    }
  } else {
    yield put(result(LINK_MERCHANT_ID, { code: Result.FAILED }));
  }
}

function* productSaga() {
  yield takeEvery(LIST, list);
  yield takeEvery(LINK_MERCHANT_ID, linkMerchant);
  yield takeEvery(UNBIND_MERCHANT_ID, unbindMerchant);
}

export default productSaga;
